import React, { useState, useEffect } from "react"
import { toast } from 'react-toastify'
import Loading from "../../components/Loading"
import MessageBox from "../../components/MessageBox"

import Arrow from './../../images/icons/drop-down.png'
import Arch from './../../images/icons/arch.png'
import Clock from './../../images/icons/clock.png'

import { apiCall, validateToken, shuffle } from './../../../Helper'
import { navigate } from "@reach/router"

import TakenExamDetailModal from './TakenExamDetailModal'

const htmlToText = require('html-to-text')

export default ({ id }) => {
  if (!id) navigate('/exam/list')

  if (typeof window !== 'undefined') window.onbeforeunload = function () { return "تایید خروج"; };

  let remaining = { minute: 0, second: 0 }
  let clockRunning = false
  let i = undefined

  const [isLoading, setIsLoading] = useState(true)
  const [examEnded, setExamEnded] = useState(false)
  const [showExamEndModal, setShowExamEndModal] = useState(false)

  const [exam, setExam] = useState({})
  const [questions, setQuestions] = useState([])
  const [activeIndex, setActiveIndex] = useState(0)
  const [time, setTime] = useState({ minute: 0, second: 0 })

  const [result, setResult] = useState({})

  const [responses, setResponses] = useState([])
  // const [answers, setAnswers] = useState([])
  const [t, setT] = useState([0, 1, 2, 3])

  function getExam() {
    setIsLoading(true)
    apiCall({
      url: '/newExams/activeExam',
      params: {
        taken_exam_id: id
      }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        let e = res.data.questions
        setExam(res.data.exam)
        setQuestions(shuffle(e))
        setResponses(res.data.questions.map(x => ({ question_id: x.question_id, response: '' })))
      }
    }).catch(err => { navigate(`/exam/taken-exams/${id}`); setIsLoading(false) })
  }
  function endExam() {
    setIsLoading(true)
    apiCall({
      url: '/newExams/takenExam',
      method: 'post',
      data: {
        taken_exam_id: id, user_responses: responses
      }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data && res.data.code === 0) {
        setShowExamEndModal(false)
        setExamEnded(true)
        setResult(res.data.data)
        clearInterval(i)
      } else { toast.error('مشکل در سیستم'); setIsLoading(false) }
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }
  function getTime() {
    return apiCall({
      url: '/newExams/time',
      params: {
        taken_exam_id: id
      }
    }).then(res => {
      if (res && res.data && res.data.code === 0) {
        setTime(res.data)
        remaining = res.data
        if (!i) runClock();
      } else {
        if (res.data.data) setResult(res.data.data)
        toast.error('آزمون پایان یافته')
        setExamEnded(true)
        clearInterval(i)
      }
    }).catch(err => { toast.error('مشکل در سیستم') })
  }

  function runClock() {
    let { minute, second } = remaining
    if (!examEnded && !clockRunning && (minute > 0 || second > 0)) {
      i = setInterval(() => {
        if (second % 10 === 0)
          !examEnded && getTime()

        if (second > 0) {
          second--
          setTime({ minute, second })
          remaining = { minute, second }
        } else if (minute > 0) {
          minute--
          second = 59
          setTime({ minute, second })
          remaining = { minute, second }
        } else {
          setExamEnded(true)
          console.log('exam ended interval')
          clearInterval(i)
        }
      }, 1000)
    } else {
      setExamEnded(true)
      console.log('exam ended else')
      clearInterval(i)
    }
    clockRunning = true
  }

  // function checkQuestion(response) {
  //   let i = responses.findIndex(x => x.question_id === exam.questions[activeIndex].question_id)
  //   console.log(i)
  //   if (i > -1)
  //     setResponses(responses.map(r => r.question_id === response.id ? { question_id: exam.questions[activeIndex].question_id, response } : r))
  //   else
  //     setResponses([...responses, { question_id: exam.questions[activeIndex].question_id, response }])
  // }
  function checkQuestion(response) {
    setResponses(responses.map((x, i) => x.question_id === questions[activeIndex].question_id ? { question_id: questions[activeIndex].question_id, response } : x))
  }

  useEffect(() => { validateToken(); getExam(); getTime(); return () => clearInterval(i) }, [])

  const answers = [
    <label className="iran-sans-light">
      <input type="checkbox" className="valign-mid ml-8"
        checked={responses[activeIndex]?.response === 1}
        onChange={() => checkQuestion(1)} />
      {questions && questions[activeIndex]?.ans_1}
    </label>,
    <label className="iran-sans-light">
      <input type="checkbox" className="valign-mid ml-8"
        checked={responses[activeIndex]?.response === 2}
        onChange={() => checkQuestion(2)} />
      {questions && questions[activeIndex]?.ans_2}
    </label>,
    <label className="iran-sans-light">
      <input type="checkbox" className="valign-mid ml-8"
        checked={responses[activeIndex]?.response === 3}
        onChange={() => checkQuestion(3)} />
      {questions && questions[activeIndex]?.ans_3}
    </label>,
    <label className="iran-sans-light">
      <input type="checkbox" className="valign-mid ml-8"
        checked={responses[activeIndex]?.response === 4}
        onChange={() => checkQuestion(4)} />
      {questions && questions[activeIndex]?.ans_4}
    </label>
  ]

  useEffect(() => { setT(shuffle(t)) }, [activeIndex])


  return (
    <div>
      <h3 className="m-0 text-shadow font-16 pr-16">آزمون</h3>
      <hr className="mb-0" />

      {/* exam item */}
      <div className="px-32">
        {/* exam title */}
        <h4 className="font-14 text-shadow">{exam.group?.title} - {exam.title}</h4>
        <div className="flexed flex-between align-end" style={{ marginTop: -32 }}>
          {/* steps */}
          <div className="flex-1 flexed justify-c ltr pb-64 pl-45 w-50">
            {/* <button disabled={activeIndex === 0} className="bd-none bg-none pb-4"
              onClick={() => { if (activeIndex > 0) setActiveIndex(activeIndex - 1) }}>
              <img src={Arrow} className="icon-xs" style={{ transform: 'rotate(90deg)' }} alt="" />
            </button> */}
            <div className="exam-nav flexe justify-c flex-1 w-75 text-center">
              <div className="scroll-hor pb-16" style={{ marginBottom: -32 }}>
                {
                  [...Array(exam.q_count)].map((item, index) => (
                    <button key={index} style={{ padding: '3px 0 0' }}
                      disabled={activeIndex > index}
                      className={`bg-${index === activeIndex ? 'tomato text-top-nav' : 'bg'} bold inline-blocked fl-c mx-16 circle p-0 exam-nav-item iran-sans font-10`}
                      onClick={() => setActiveIndex(index)}
                    >{index + 1}</button>
                  ))
                }
              </div>
            </div>
            <button disabled={activeIndex === questions.length - 1} className="bd-none bg-none pb-4"
              onClick={() => { if (activeIndex < (questions.length - 1)) setActiveIndex(activeIndex + 1) }}>
              <img src={Arrow} className="icon-xs" style={{ transform: 'rotate(-90deg)' }} alt="" />
            </button>
          </div>
          {/* clock */}
          <div>
            <img src={Clock} style={{ width: 128 }} alt="" />
            <div className="time-wrapper ltr">
              <div className="pie spinner" style={{ transform: `rotate(${(exam ? ((((time.minute * 60) + time.second) / (exam.time * 60)) * 100) / 100 * 360 : 0)}deg)` }} />
              <div className="pie filler" style={{ opacity: exam ? (((((time.minute * 60) + time.second) / (exam.time * 60)) * 100) / 100 * 360 > 180 ? 1 : 0) : 0 }} />
              <div className="mask" style={{ opacity: exam ? (((((time.minute * 60) + time.second) / (exam.time * 60)) * 100) / 100 * 360 > 180 ? 0 : 1) : 0 }} />
              <div className="time">
                <span className="minute text-top-nav text-center font-11 bold"
                  style={{ marginBottom: -2 }}
                >{time.minute >= 10 ? time.minute : '0' + time.minute}</span>
                <span className="second text-top-nav text-center font-8 bold">{time.second >= 10 ? time.second : '0' + time.second}</span>
              </div>
            </div>
          </div>
        </div>

        {/* question */}
        <div className="bg-top-nav p-16 pb-32 mt-16 radius-4">
          <h4 className="m-0 text-shadow pr-16">سوال {activeIndex + 1}</h4>
          <hr />
          <p className="px-16 text-shadow mb-0" style={{ lineHeight: 2.3 }}>{htmlToText.fromString(questions && questions[activeIndex]?.text)}</p>
          <br />
          {/* answers */}
          <div className="grid px-32" style={{ gap: 22 }}>
            {answers[t[0]]}
            {answers[t[1]]}
            {answers[t[2]]}
            {answers[t[3]]}
          </div>
        </div>

        {/* bott */}
        <div className="flexed justify-between align-c mt-32">
          <div>
            <button className="bg-none bd-none text-tomato p-0 font-24 pl-16"
              disabled={activeIndex === questions.length - 1}
              onClick={() => { if (activeIndex < (questions.length - 1)) setActiveIndex(activeIndex + 1) }}>
              <img src={Arch} style={{ width: 42 }} alt="" />
            </button>
            {/* <button className="bg-none bd-none text-tomato p-0 font-24 pr-4"
              disabled={activeIndex === 0}
              onClick={() => { if (activeIndex > 0) setActiveIndex(activeIndex - 1) }}>
              <img src={Arch} style={{ width: 42, transform: 'rotate(180deg)' }} alt="" />
            </button> */}
          </div>
          <div>
            <button className="text-tomato bg-none py-5 px-32 radius-4 iran-sans" style={{ border: '1px solid' }}
              onClick={() => setShowExamEndModal(true)}>اتمام آزمون</button>
          </div>
        </div>
      </div>

      <TakenExamDetailModal full show={examEnded} toggleShow={() => { }} exam={result} noAction toDetails />
      <MessageBox full show={showExamEndModal} toggleShow={setShowExamEndModal} title="اتمام آزمون" description="آیا از اتمام آزمون مطمئن هستید" onAccept={endExam} />
      <Loading full show={isLoading} />
    </div>
  )
}
